import { render, staticRenderFns } from "./noticesAndFilesPagination.vue?vue&type=template&id=2b265895&scoped=true&"
import script from "./noticesAndFilesPagination.vue?vue&type=script&lang=js&"
export * from "./noticesAndFilesPagination.vue?vue&type=script&lang=js&"
import style0 from "./noticesAndFilesPagination.vue?vue&type=style&index=0&id=2b265895&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b265895",
  null
  
)

export default component.exports